import CheckIcon from '@mui/icons-material/Check';
import { ListItemText } from '@mui/material';

import { ReactComponent as GroupIcon } from '@/assets/icons/GroupWorkRounded.svg';

import { useGeneratikTableContext } from '../GeneratikTableContext';
import ContextSubmenu from './ContextSubmenu';
import { CONTEXT_MENU_TESTIDS, groupOptionTestId } from './tableContextMenu.constants';
import { ContextMenuItem } from './tableContextMenu.styles';
import { applyGroup } from './tableContextMenuActions';

interface Props {
  onAfterAction: () => void;
}

const GroupBySubmenu = ({ onAfterAction }: Props) => {
  const ctx = useGeneratikTableContext();

  return (
    <ContextSubmenu
      icon={<GroupIcon />}
      label={ctx.t('group_by')}
      testId={CONTEXT_MENU_TESTIDS.groupBy}
      onAfterAction={onAfterAction}
    >
      {(close) =>
        (ctx.groupOptions ?? []).map((o) => (
          <ContextMenuItem
            key={o.field}
            selected={ctx.groupByField === o.field}
            onClick={() => {
              applyGroup(o.field, { onGroupChange: ctx.onGroupChange });
              close();
            }}
            data-testid={groupOptionTestId(o.field)}
          >
            <ListItemText>{o.label}</ListItemText>
            {ctx.groupByField === o.field && <CheckIcon fontSize="small" />}
          </ContextMenuItem>
        ))
      }
    </ContextSubmenu>
  );
};

export default GroupBySubmenu;
